<template>
  <div class="conMain flex_column_start_center">
    <!-- 顶部tab切换 -->
    <van-tabs type="card" v-model="activeName">
      <van-tab title="烈冰传奇系列" name="first"></van-tab>
      <van-tab title="单机游戏系列" name="second"></van-tab>
    </van-tabs>
    <div class="gameCon">
      <div
        v-for="(item, index) in list[activeName]"
        :key="index"
        class="gameItem flex_column_start_center"
      >
        <!-- banner图 -->
        <img :src="item.bannerUrl" alt="" class="bannerImg" />
        <div class="flex_between_center gameDetail">
          <div class="flex_column_center_start">
            <div class="flex_between_center">
              <!-- 游戏icon -->
              <img :src="item.iconUrl" alt="" class="iconGame" />
              <div class="flex_column_start_start">
                <!-- 游戏名称 -->
                <div class="nameGame">{{ item.name }}</div>
                <div class="flex_start_start nameTags">
                  <div
                    class="nameTag"
                    v-for="(item1, index1) in item.tag"
                    :key="index1"
                  >
                    <!-- 游戏标签 -->
                    <div class="specialTag">{{ item1 }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 游戏描述 -->
            <div class="gameDesc">{{ item.desc }}</div>
          </div>
          <!-- 下载按钮 -->
          <div class="btnDesc" @click="handleDownload(item.downloadUrl)">
            {{ item.btnDesc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      activeName: "first",
      list: {},
    }; //data结束
  },
  watch: {},
  created() {
    this.list = this.$publicData.list;
  },

  methods: {
    handleDownload(url) {
      window.open(url);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="@/assets/css/flex.css"></style>
<style src="@/assets/css/index/deep.css"></style>
<style scoped src="@/assets/css/index/index.css"></style>





// WEBPACK FOOTER //
// src/views/index.vue